module.exports = __webpack_public_path__ + "img/debt-cover.1c4cc7e6.jpg";